import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import HotelPricingAssistantTableCellsTdCompetitorsRate from 'lumen/components/hotel/pricing-assistant/table/cells/td-competitors-rate';
import type { TablePricingManagerContextColumn } from 'lumen/components/hotel/pricing-assistant/table/table-pricing-manager';
import type { Period, Rate } from 'lumen/models';

interface HotelPricingAssistantTableCellsTdCompetitorRateMonthSignature {
  Args: {
    column: TablePricingManagerContextColumn;
    row: { period: Period };
    value: Rate | undefined;
  };
}

// The competitor cell needs a rate, which a competitor can lack on a given day.
export default class HotelPricingAssistantTableCellsTdCompetitorRateMonth extends Component<HotelPricingAssistantTableCellsTdCompetitorRateMonthSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  get isPast(): boolean {
    return this.hotelAndMarketService.isPast(this.args.row.period.fromDate);
  }

  <template>
    {{#if @value}}
      <HotelPricingAssistantTableCellsTdCompetitorsRate
        @column={{@column}}
        @value={{@value}}
      />
    {{else}}
      <div
        class="mr-500 {{if this.isPast 'text-disabled' 'text-neutral-subdued'}}"
        data-test-id="td-competitor-rate-month-missing"
      >
        {{t "general.missing"}}
      </div>
    {{/if}}
  </template>
}
